import{css}from'glamor';export var locationName=css({margin:0,color:'var(--color-text-high-emphasis)',fontSize:'1rem',fontWeight:500});